"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateWindowRelativeDateComponent = void 0;
var metrics_engine_1 = require("@tableau/metrics-engine");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../../gen-src/Localize");
var shakeInputIfInvalid_1 = require("../../../shakeIfInvalid/shakeInputIfInvalid");
var DateWindowRelativeDateComponent = function (props) {
    var startingUnits = unitsToStartWith(props.selectedDateWindow, props.dateTrunc);
    var _a = React.useState(false), hasBeenEdited = _a[0], setHasBeenEdited = _a[1];
    var _b = React.useState(startingUnits), relativeUnits = _b[0], setRelativeUnits = _b[1];
    React.useEffect(function () {
        props.onDateWindowChange(relativeUnits ? createWindow(relativeUnits) : null);
    }, [relativeUnits]);
    var createWindow = function (numberOfUnits) {
        if (props.dateTrunc === metrics_engine_1.DateTrunc.UNKNOWN) {
            return (0, metrics_engine_1.createLastNWindow)(numberOfUnits);
        }
        else {
            return (0, metrics_engine_1.createRelativeWindow)({
                unit: props.dateTrunc,
                numberOfUnits: numberOfUnits,
            });
        }
    };
    var onBlur = function () {
        setHasBeenEdited(true);
    };
    var handleChange = function (value) {
        setHasBeenEdited(true);
        var parsed = parseInt(value, 10);
        var finalValue = isNaN(parsed) ? null : parsed;
        setRelativeUnits(finalValue);
    };
    var invalid = hasBeenEdited && !(0, metrics_engine_1.isValidRelativeDateRangeInput)(relativeUnits);
    var inputRef = React.createRef();
    React.useEffect((0, shakeInputIfInvalid_1.shakeInputIfInvalid)(invalid, inputRef), [props.validationCounter]);
    return (React.createElement(React.Fragment, null,
        React.createElement(widgets_1.TextFieldWidget, __assign({}, {
            ref: inputRef,
            kind: 'outline',
            value: relativeUnits !== null && relativeUnits !== void 0 ? relativeUnits : '',
            onChange: function (e) { return handleChange(e.target.value); },
            onBlur: onBlur,
            valid: invalid ? false : undefined,
            message: invalid ? Localize_1.Messages.RelativeDateWindowInputErrorMessage() : React.createElement("br", null),
            testId: props.testId,
            label: '',
            min: metrics_engine_1.MINIMUM_RELATIVE_UNITS,
            max: metrics_engine_1.MAXIMUM_RELATIVE_UNITS,
            disabled: props.disabled,
        }))));
};
exports.DateWindowRelativeDateComponent = DateWindowRelativeDateComponent;
var unitsToStartWith = function (window, metricDateTrunc) {
    if (window === null) {
        return 1;
    }
    if ((0, metrics_engine_1.isLatestDataWindow)(window)) {
        var units = window.duration.numberOfUnits;
        if (window.duration.unit !== metricDateTrunc) {
            if (window.duration.unit === metrics_engine_1.DateTrunc.MINUTE) {
                return (0, metrics_engine_1.getUnitsInSeconds)(window.duration.unit, units);
            }
            else if (window.duration.unit === metrics_engine_1.DateTrunc.HOUR) {
                return (0, metrics_engine_1.getUnitsInMinutes)(window.duration.unit, units);
            }
            else if (window.duration.unit === metrics_engine_1.DateTrunc.DAY) {
                return (0, metrics_engine_1.getUnitsinHours)(window.duration.unit, units);
            }
        }
        return units;
    }
    if ((0, metrics_engine_1.isLastNWindow)(window)) {
        return window.n;
    }
    return 1;
};
//# sourceMappingURL=DateWindowRelativeDateComponent.js.map